import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
// import TextField from "@material-ui/core/TextField"

import XsButton from "../../../../../global/ui/xsButton/xsButton"
import MultiStornoDialogStore from "../../../stores/MultiStornoDialogStore"

@observer
export default class MultiStornoDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				id="xsMultiStornoDialog"
				open={MultiStornoDialogStore.isOpen}
				onClose={() => MultiStornoDialogStore.close()}
				disableBackdropClick={true}
				maxWidth="md"
				className="xs-base-dialog"
			>
				<DialogTitle className="xs-danger">
					<div className="xs-header">
						<div className="xs-header-icon">
							<i className="fal fa-trash-alt fa-2x" />
						</div>
						<div className="xs-header-title">
							<FormattedMessage id="Common.label.warning" />
						</div>
					</div>
				</DialogTitle>
				<DialogContent className="xs-content">
					<div className="nx-body">
						{MultiStornoDialogStore.recordIds && MultiStornoDialogStore.recordIds.length > 1 ? (
							<FormattedMessage id="Common.label.MultipleCancelPrompt" />
						) : (
							<FormattedMessage id="Patient.form.patientPrescription.cancelPrescriptionText" />
						)}
					</div>
					{/* <TextField
						label={<FormattedMessage id="PatientDetail.overview.recordStornoTitle" />}
						className="dialog-cancel-input"
						value={MultiStornoDialogStore.reason}
						onChange={(e) => MultiStornoDialogStore.onHandleChange(e.target.value)}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
						autoFocus
					/> */}
				</DialogContent>
				<DialogActions className="xs-footer xs-space-between">
					<XsButton
						className="xs-default xs-outline action-close"
						icon={<i className="fal fa-times" />}
						text={<FormattedMessage id="Common.btn.not.storno" />}
						onClick={() => MultiStornoDialogStore.close()}
					/>
					<XsButton
						className="xs-danger action-cancel"
						icon={<i className="fal fa-trash-alt" />}
						text={<FormattedMessage id="Common.btn.modal.storno" />}
						onClick={() => {
							MultiStornoDialogStore.storno()
						}}
					/>
				</DialogActions>
			</Dialog>
		)
	}
}
